
(function(){
	"use strict";

	function initBeforeAfter(root)
	{
		if (!root) return;

		root.classList.remove("ba-nojs");
		const handle      = root.querySelector(".ba-handle");
		const beforeImg   = root.querySelector(".ba-before");
		let pos = 50;
		let dragging = false;

		function setPos(p)
		{
			pos = Math.max(0, Math.min(100, p));
			root.style.setProperty("--pos", pos + "%");
			handle.style.insetInlineStart = `calc(${pos}% - 1px)`;
			handle.setAttribute("aria-valuenow", String(Math.round(pos)));
		}

		function clientXToPercent(clientX)
		{
			const rect = root.getBoundingClientRect();
			const x = clientX - rect.left;
			return (x / rect.width) * 100;
		}

		function onPointerDown(ev)
		{
			if (!ev) return;
			dragging = true;
			handle.focus();
			ev.preventDefault?.();
			root.setPointerCapture?.(ev.pointerId);
			setPos(clientXToPercent(ev.clientX));
		}

		function onPointerMove(ev)
		{
			if (!dragging || !ev) return;
			ev.preventDefault?.();
			setPos(clientXToPercent(ev.clientX));
		}

		function onPointerUp()
		{
			dragging = false;
		}

		function onPointerCancel()
		{
			dragging = false;
		}

		function onKeyDown(ev)
		{
			const step = ev.shiftKey ? 10 : 2;
			if (ev.key === "ArrowLeft")  { setPos(pos - step); ev.preventDefault(); }
			if (ev.key === "ArrowRight") { setPos(pos + step); ev.preventDefault(); }
			if (ev.key === "Home")       { setPos(0); ev.preventDefault(); }
			if (ev.key === "End")        { setPos(100); ev.preventDefault(); }
		}

		function onClick(ev)
		{
			if (dragging || !ev) return;
			setPos(clientXToPercent(ev.clientX));
		}

		setPos(50);

		root.addEventListener("pointerdown", onPointerDown, { passive: false });
		window.addEventListener("pointermove", onPointerMove, { passive: false });
		window.addEventListener("pointerup", onPointerUp, { passive: false });
		window.addEventListener("pointercancel", onPointerCancel, { passive: false });
		handle.addEventListener("keydown", onKeyDown);
		root.addEventListener("click", onClick);
		window.addEventListener("resize", () => setPos(pos));
	}

	document.querySelectorAll(".ba-slider").forEach(initBeforeAfter);
})();
